import React from 'react';
import classNames from 'classnames';

import './AnswerMessage.scss';

type Variant = 'success' | 'fail';

const VariantToClassname: Record<Variant, string> = {
  fail: 'widget-answer-message--fail',
  success: 'widget-answer-message--success',
};

type AnswerMessageProps = {
  variant: Variant;
  children: React.ReactNode;
};

export const AnswerMessage: React.FC<AnswerMessageProps> = ({ variant, children }) => {
  return <div className={classNames('widget-answer-message', VariantToClassname[variant])}>{children}</div>;
};
